module.exports = __webpack_public_path__ + "media/images/athletes/4147-fefce00367a41f4ef68a30f88e395f88.png";